gsap.registerPlugin(ScrollTrigger);

const adaptHeader = document.querySelector('.adapt-header');
const adaptContent = document.querySelector('.adapt-content');
const adaptNav = document.querySelector('#adapt-nav');
const adaptFooter = document.querySelector('#categories-butt');
const galleryContainer = document.querySelector("#gallery");
const galleryTotalScrollWidth = galleryContainer.scrollWidth - window.innerWidth;

window.onload = function () {
  setTimeout(() => {
    window.scrollTo(0, 0);
    ScrollTrigger.clearScrollMemory();
    window.history.scrollRestoration = "manual";
  }, "200");
};

//scroll indicator
ScrollTrigger.create({
  trigger: ".adapt-content",
  start: "top 200px",
  onEnter: () => {
    gsap.to(".scroll-indicator", { opacity: 0, duration: 0.5 });
  },
  onLeaveBack: () => {
    gsap.to(".scroll-indicator", { opacity: 1, duration: 0.5 });
  },
});

//sticky header
ScrollTrigger.create({
    trigger: '#shopify-section-header',
    start: 'bottom top',
    onEnter: () => {
      adaptHeader.classList.add('adapt-header-sticky');
      adaptContent.style.marginTop = `${adaptHeader.clientHeight}px`;
    },
    onLeaveBack: () => {
      adaptHeader.classList.remove('adapt-header-sticky');
      adaptContent.style.marginTop = `unset`;
    }
});


//sticky footer
setTimeout(() => {
  ScrollTrigger.create({
      markers: false,
      trigger: '.footer',
      start: `top bottom-=${adaptFooter.clientHeight}px`,
      onEnter: () => {
        adaptFooter.style.position = 'relative';
      },
      onLeaveBack: () => {
        adaptFooter.style.position = 'fixed';
      }
  });
}, "250");

//progressbar
setTimeout(() => {
gsap.to(".progress", {
    width: "100%", // Full width on complete scroll
    ease: "none",
    scrollTrigger: {
        markers: false,
        trigger: ".adapt-content",
        start: "top top",
        end: 'bottom bottom', // Total scroll distance
        scrub: true, // Sync with scroll progress
    },
});
}, "1000");  



//categories
const categoriesButt = document.querySelector('#categories-butt');
const categoriesClose = document.querySelector('#categories-close');

categoriesButt.addEventListener("click", (e) => {
  document.querySelector('#adapt-categories').style.display = 'flex';
});

categoriesClose.addEventListener("click", (e) => {
  document.querySelector('#adapt-categories').style.display = 'none';
});

if(document.getElementById('compare')) {
  let tl_compare = gsap.timeline({
      scrollTrigger: {
          markers: false,
          trigger: '#compare',
          start: 'top 70%',
          end: '+=500',
          scrub: 1,
      }
  });
  
  tl_compare
    .addLabel('start')
      .fromTo('#compare .box', { scale: 0, autoAlpha: 0}, { scale: 1, autoAlpha: 1, ease: "smooth"})
    .addLabel('text')
      .fromTo('#compare .box-copy-container', { autoAlpha: 0}, { autoAlpha: 1, ease: "smooth"})
    .addLabel('end')
}

// fnb pops
let fnbPopShow = function(fnbType) {
  document.getElementById(`${fnbType}_link`).style.display = 'none'
  document.getElementById(fnbType).style.display = 'flex';
}
let fnbPopClose = function(fnbType) {
  document.getElementById(`${fnbType}_link`).style.display = 'block'
  document.getElementById(fnbType).style.display = 'none';
}

//explore
let tl_shoppable = gsap.timeline({
    scrollTrigger: {
        markers: false,
        trigger: '#shoppable',
        start: 'top 70%',
        end: 'bottom bottom',
        scrub: 1,
    }
});
  
tl_shoppable
  .addLabel('start')
    .fromTo('#shoppable .box', { scale: 0, autoAlpha: 0}, { scale: 1, autoAlpha: 1, ease: "smooth"})
  .addLabel('text')
    .fromTo('#shoppable .box-copy-container', { autoAlpha: 0}, { autoAlpha: 1, ease: "smooth"})
  .addLabel('end')



$(window).on('unload', function() {
  ScrollTrigger.clearScrollMemory();
  $(window).scrollTop(0);
});